import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Table, TableBody,
     TableContainer, TableHead, TableRow, Divider, Grow, Popper, MenuList, MenuItem, ClickAwayListener } from "@material-ui/core";
import React, { FC, ReactElement, useEffect, useState } from "react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import { useHistory } from "react-router-dom";
import MetaMappingService from "../../services/MetaMappingService";
import { MetaMapping } from "../../models/MetaMapping";
import SourceConnectionService from "../../services/SourcesConnectionService";
import MessageBox from "../../components/message/MessageBox";
import { Alert } from "@material-ui/lab";
import EditIcon from '@material-ui/icons/Edit'
// import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import MenuIcon from '@material-ui/icons/Menu';


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#7CCCEE',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const OptionsTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#7CCCEE',
        color: theme.palette.common.white,
    },
    root: {
        borderLeftWidth: 1,
        borderLeftColor: theme.palette.grey[300],
        borderLeftStyle: "solid",
      },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 700,
    },
    primaryButton: {
        margin: theme.spacing(.5),
        backgroundColor: '#349CC9',
        color: 'white',
        minWidth: 125
    },
    actionButton: {
        margin: theme.spacing(.5),
        backgroundColor: '#03a184',
        color: 'white',
        minWidth: 125
    },
    secondaryButton: {
        //margin: theme.spacing(1),
        minWidth: 70,
        marginBottom: '4px',
        backgroundColor: '#7CCCEE',
        color: 'white',
        fontSize: 11,
        justifyContent: "center"
    }
  }));

const SourceMetaListView: FC = (): ReactElement => {

    const {
        getAllMetaMappings,
        deleteMetaMapping,
    } = MetaMappingService();

    const {
        load
    } = SourceConnectionService();

    const classes = useStyles();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [sources, setSources] = useState<MetaMapping[]>();
    const [alertMessage, setAlertMessage] = useState<{ title, message, severity }>();

    const [selectedMappingId, setSelectedMappingId] = useState<number>();   // used for delete
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    
    const [selectedMapping, setSelectedMapping] = useState<MetaMapping>();
    const [migrate, setMigrate] = useState(false);
    const [migrating, setMigrating] = useState(false);

    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentRow, setCurrentRow] = useState<MetaMapping>();
    
    const loadMetaMappings = () => {
        setLoading(true);
        getAllMetaMappings().then(res => {
            setSources(res);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        loadMetaMappings();
    }, []);

    useEffect(() => {
        if (selectedMappingId) {
            setOpenConfirmationModal(true);
        }
    }, [selectedMappingId]);

    const closeConfirmationModal = () => {
        setOpenConfirmationModal(false);
        setSelectedMappingId(null);
    };

    useEffect(() => {
        if (selectedMapping) {
            setMigrate(true);
        }
    }, [selectedMapping]);

    const migrateData = (mappingID: number) => {
        setMigrating(true);
        setMigrate(false);

        load(mappingID).then(data => {
            if(data.success){
                setAlertMessage({
                    message: 'Migration process started',
                    severity: 'success',
                    title: 'Data migration process'
                });
            }else{
                setAlertMessage({
                    message: data.error[0],
                    severity: 'error',
                    title: 'Data migration process'
                });
            }
        }).catch(error => {
            setAlertMessage({
                message: 'Migration failed to start',
                severity: 'error',
                title: 'Data migration process'
            });        
        }).finally(() => {
            setMigrating(false);
            setSelectedMapping(null);
        });
    }

    const handleMenuToggle = (row: MetaMapping, event) => {        
        if(anchorEl !== null){
            setMenuOpen(false);            
            setAnchorEl(null);
            setCurrentRow(null);           
        }else{
            setAnchorEl(event.currentTarget);
            setCurrentRow(row);
            setMenuOpen(true);
        }
    };
    
    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={10}>
                </Grid>
                <Grid item xs={2} style={{textAlign: 'right'}}>
                    <Button
                        variant="contained"
                        className={classes.primaryButton}
                        endIcon={<PlaylistAddIcon />}
                        onClick={() => { history.push('/sources-meta/add') }}
                    >
                        Add
                    </Button>
                </Grid>
            </Grid>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Mapping Name</StyledTableCell>
                            <StyledTableCell>Prefix</StyledTableCell>
                            <StyledTableCell>Origin Connection</StyledTableCell>
                            <StyledTableCell>Destination Connection</StyledTableCell>
                            <StyledTableCell style={{width: '12%'}}></StyledTableCell>
                            <StyledTableCell style={{width: '4%'}}></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && sources && sources.map((row) => (
                            <StyledTableRow key={row.name}>
                                <StyledTableCell component="th" scope="row">
                                    {row.name}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                    {row.prefix}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                    {row.sourceConnectionOrigin.name}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                    {row.sourceConnectionDestination.name}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row" style={{textAlign: 'right'}}>
                                    <Button
                                        variant="contained"
                                        className={classes.actionButton}
                                        onClick={() => { setSelectedMapping(row) }}
                                    >
                                        Run
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.primaryButton}
                                        endIcon={<NavigateNextIcon />}
                                        onClick={() => { history.push(`/sources-meta/setup/${row.id}`) }}
                                    >
                                        Setup
                                    </Button>
                                </StyledTableCell>
                                <OptionsTableCell component="th" scope="row" style={{textAlign: 'center'}}>
                                    <Button
                                        //className={classes.secondaryButton}
                                        aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                                        aria-haspopup="true"
                                        onClick={event => handleMenuToggle(row, event)}
                                    >
                                        <MenuIcon fontSize="medium" />
                                    </Button>                                   
                                </OptionsTableCell>
                            </StyledTableRow>
                        ))}
                        {loading && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={5} style={{textAlign: 'center'}}>Loading...</StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Popper open={menuOpen} anchorEl={anchorEl} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleMenuClose}>
                            <MenuList autoFocusItem={menuOpen} id="menu-list-grow">
                                <MenuItem onClick={() => { history.push(`/sources-meta/edit/${currentRow.id}`) }} >Edit</MenuItem>
                                <MenuItem onClick={() => { setSelectedMappingId(currentRow.id) }} >Delete</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
                )}
            </Popper>

            <Dialog
                open={openConfirmationModal}
                keepMounted
                onClose={closeConfirmationModal}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{`Delete Mapping`}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {'Are you sure you want to delete ' + currentRow?.name + '?'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        deleteMetaMapping(selectedMappingId).then(res => {
                            if (res) {
                                loadMetaMappings();
                            } else {
                                setAlertMessage({
                                    message: 'This mapping is being used and can`t be deleted.',
                                    severity: 'warning',
                                    title: 'Delete Error'
                                });
                            }
                            closeConfirmationModal();
                        })
                    }} color="primary"> 
                        Delete 
                    </Button>
                    <Button onClick={closeConfirmationModal}
                            color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <MessageBox
                onOk={() => {
                    setAlertMessage(undefined);
                }}
                onWondowClose={() => {
                    setAlertMessage(undefined);
                }}
                show={alertMessage != undefined}
                title={alertMessage?.title}
            >
                <Alert severity={alertMessage?.severity}>{alertMessage?.message}</Alert>
            </MessageBox>

            {sources && <Dialog
                open={migrate}
                keepMounted
                onClose={() => {
                    setMigrate(false);
                    setSelectedMapping(null);
                }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{`Data Migration from ${selectedMapping?.sourceConnectionOrigin.name} to ${selectedMapping?.sourceConnectionDestination.name}`}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you wan't to procceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        migrateData(selectedMapping?.id);
                    }} color="primary"> 
                        Proceed 
                    </Button>
                    <Button onClick={()=>{
                        setMigrate(false);
                        setSelectedMapping(null);
                    }}
                    color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>}
        </div>
    )
}

export default SourceMetaListView;